/**
 * react-query-devtools-noop
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function ReactQueryDevtools() {
  return null;
}
function ReactQueryDevtoolsPanel() {
  return null;
}
export { ReactQueryDevtools, ReactQueryDevtoolsPanel };